import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "@emotion/styled";
import enUSMsg from "@/utils/languages/en-us.json";
import {mq} from "@/utils/mediaQuery";

const Text = styled.span(
  ({ theme, fontSize, color, underline, ellipsis, lineHeight, secondary }) => ({
    fontFamily: secondary ? theme.fontFamily.secondaryFont :theme.fontFamily.primaryFont,
    fontWeight: theme.fontWeight.regular,
    fontSize: fontSize ? fontSize : "1.6rem",
    color: color ? color : theme.color.base_black,

    overflow: ellipsis ? "hidden" : "",
    whiteSpace: ellipsis ? "nowrap" : "",
    textOverflow: ellipsis ? "ellipsis" : "",
    textDecoration: underline ? "underline" : "",
    cursor: underline ? "pointer" : "",
    lineHeight: lineHeight ?? "",

    [mq("desktop")] : {
      fontSize: fontSize ? fontSize : "1.8rem",
    }
  })
);

const RegularText = ({
  id,
  children,
  fontSize,
  color,
  underline,
  ellipsis,
  lineHeight,
  className,
  onClick,
  secondary
}) => {
  return (
    <Text
      fontSize={fontSize}
      color={color}
      underline={underline}
      ellipsis={ellipsis}
      lineHeight={lineHeight}
      className={className}
      onClick={onClick}
      secondary={secondary}
    >
      {id && <FormattedMessage id={id} defaultMessage={enUSMsg[id]} />}

      {children}
    </Text>
  );
};

export default RegularText;
